import { ChevronRight } from 'lucide-react';
import Icon from '@/components/primitives/Icon.jsx';
import ExecutionStatus from '@/components/surfaces/ExecutionStatus.jsx';
import toStepDetails from '../lib/toStepDetails.js';

/**
 * The steps Pieve took between two messages, drawn as one continuous line with a node per step.
 * Each step says what Pieve did in plain words and its state; opening it shows the app, the action
 * and the exact input and result, so every action can be checked.
 */
const StepTrail = ({ steps }) => {
  return (
    <ol className="assistant-trail" aria-label="Steps Pieve took">
      {steps.map((step) => {
        const details = toStepDetails(step.args);

        return (
          <li key={step.id} className="assistant-trail__step" data-state={step.state}>
            <span className="assistant-trail__node" aria-hidden="true" />
            <details className="assistant-trail__details">
              <summary className="assistant-trail__summary">
                <span className="assistant-trail__label">{step.label}</span>
                <span className="assistant-trail__state">
                  <ExecutionStatus state={step.state} size="sm" />
                </span>
                <span className="assistant-trail__chevron">
                  <Icon icon={ChevronRight} size="sm" />
                </span>
              </summary>
              <dl className="assistant-trail__facts">
                {details.facts.map((fact) => (
                  <div key={fact.label} className="assistant-trail__fact">
                    <dt>{fact.label}</dt>
                    <dd>{fact.value}</dd>
                  </div>
                ))}
              </dl>
              {details.input && (
                <div className="assistant-trail__data">
                  <span className="assistant-trail__data-label">Input</span>
                  <pre>{details.input}</pre>
                </div>
              )}
              {details.result && (
                <div className="assistant-trail__data">
                  <span className="assistant-trail__data-label">Result</span>
                  <pre>{details.result}</pre>
                </div>
              )}
            </details>
          </li>
        );
      })}
    </ol>
  );
};

export default StepTrail;
